import axios from 'axios'

const ROUTE = '/rest/v4/contacts';

export default {

  loadData(id) {
    return axios.get(`${ROUTE}/` + id)
  },

  loadContactsByCompanyId(id) {
    return axios.get(`${ROUTE}`, { params: { company: id } });
  },

  loadContactsByCompanyName(companyName) {
    return axios.get(`${ROUTE}`, { params: { isCompany: true, companyName: companyName } });
  },

  load(filterConfig, page, size) {
    return axios.get(`${ROUTE}`, { params: { search: filterConfig.searchExpression, page, size } });
  },

  post(data) {
    return axios.post(`${ROUTE}`, data);
  },

  cloneAttributes(id, data){
    return axios.post(`${ROUTE}/${id}/copyattributes`, data);
  },

  getContactWayTypes() {
    return axios.get(`${ROUTE}/contactwaytypes`)
  },

  getContactContactWays(id) {
    return axios.get(`${ROUTE}/${id}/contactways`)
  },

  getFormattedContactWayValue(typeId, value) {
    return axios.get(`${ROUTE}/formatters/contactways/formattedvalue`,{ params: { typeId, value } } );
  },

  getContactSyncByFormId(formId) {
    return axios.get(`${ROUTE}/${formId}/sync`);
  },

  postContactSync(formId, syncNestedContacts) {
    return axios.post(`${ROUTE}/${formId}/sync`, {
      syncNestedContacts: syncNestedContacts,
    });
  },

  getContracts(contactId) {
    return axios.get(`${ROUTE}/${contactId}/contracts`);
  },

  getStandardAddress(contactId) {
    return axios.get(`${ROUTE}/${contactId}/contactaddresses/standard`)
  },

  getContactAddresses(contact, params = {}) {
    return axios.get(`${ROUTE}/${contact}/contactaddresses`, { params })
  },
}